export const regular = 16;

export const enlarged = 18;

export const large = 36;
